export enum ScreeningStatus {
  APPROVED = "approved",
  PENDING_APPROVAL = "pending_approval",
  REJECTED = "rejected",
  INACTIVE = "inactive",
  SUSPENDED = "suspended",
  DORMANT = "dormant",
  DOCNEEDRESUBMISSION = "documents_need_resubmission",
  PENDING_DOCS = "pending_docs",
}
